import {GetDrawerRecommendationsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {DrawerBody} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {NavigationAdvertisement} from './NavigationAdvertisement';
import {NavigationCollection} from './NavigationCollection';
import {NavigationExclusives} from './NavigationExclusives';
import {NavigationLastSeenProducts} from './NavigationLastSeenProducts';
import {NavigationSports} from './NavigationSports';
import {NavigationTopBrands} from './NavigationTopBrands';

export interface NavigationRecommendationsViewProps {
  items: GetDrawerRecommendationsResponse[];
  isVisible: boolean;
  wrapperComp?: React.ComponentType<any>;
}

export const NavigationRecommendationsView: React.FC<
  NavigationRecommendationsViewProps
> = ({isVisible, items, wrapperComp}) => {
  const Wrapper = wrapperComp || React.Fragment;

  return (
    <>
      {items.map(item => {
        const section = item.recommendation.section;

        switch (section?.$case) {
          case 'collection':
            return (
              <Wrapper key="collection">
                <NavigationCollection
                  collection={section.collection}
                  isVisible={isVisible}
                />
              </Wrapper>
            );
          case 'brands':
            return (
              <Wrapper key="brands">
                <NavigationTopBrands
                  brands={section.brands}
                  isVisible={isVisible}
                />
              </Wrapper>
            );
          case 'exclusives':
            return (
              <Wrapper key="exclusives">
                <NavigationExclusives exclusives={section.exclusives} />
              </Wrapper>
            );
          case 'lastSeenProducts':
            return (
              <Wrapper key="lastSeenProducts">
                <NavigationLastSeenProducts
                  lastSeenProducts={section.lastSeenProducts}
                />
              </Wrapper>
            );
          case 'sports':
            return (
              <Wrapper key="sports">
                <NavigationSports sports={section.sports} />
              </Wrapper>
            );
          case 'advertisement':
            return (
              <NavigationAdvertisementWrapper key="advertisement">
                <NavigationAdvertisement
                  advertisement={section.advertisement}
                  isVisible={isVisible}
                />
              </NavigationAdvertisementWrapper>
            );
          default:
            return null;
        }
      })}
    </>
  );
};

const NavigationAdvertisementWrapper = styled(DrawerBody)`
  border-top: none;
  margin-bottom: 10px;
`;
